var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionnairesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 5H21.25V16.25H5V18.75C5 19.4375 5.5625 20 6.25 20H20L25 25V6.25C25 5.5625 24.4375 5 23.75 5ZM18.75 12.5V1.25C18.75 0.5625 18.1875 0 17.5 0H1.25C0.5625 0 0 0.5625 0 1.25V18.75L5 13.75H17.5C18.1875 13.75 18.75 13.1875 18.75 12.5Z",
    fill: "#737791"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionnairesIcon);
export default __webpack_public_path__ + "static/media/questionnaires-icon.a569f348ecb7752f902d126f742158f8.svg";
export { ForwardRef as ReactComponent };